import { render, staticRenderFns } from "./saleBanner.vue?vue&type=template&id=c7aaf538&scoped=true"
import script from "./saleBanner.vue?vue&type=script&lang=js"
export * from "./saleBanner.vue?vue&type=script&lang=js"
import style0 from "./saleBanner.vue?vue&type=style&index=0&id=c7aaf538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7aaf538",
  null
  
)

export default component.exports